export const urls = {
  GET_DNEVNIK: 'RNSZaposleniOpisRadovaTeren/rn_servisni_opisi_radova',
};
